import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import React from 'react';

import { Table } from './components/Table';

/**
 * ReportLog
 *
 * @TODO - Needs description.
 *
 * @param assets
 * @param query
 * @returns {Element}
 * @constructor
 */
export function ReportLog({ assets, query }) {
  const [ListSourceReportHistory, { data, error, isFetching, isLoading, refetch }] = query;

  return (
    <ErrorHandler location="src/pages/private/Dashboards/SourceReportsDashboard/components/ReportLog/ReportLog.jsx">
      <Widget title="Report Log">
        <Table
          assets={assets}
          error={error}
          isLoading={isLoading || isFetching}
          refetch={refetch}
          requestArgs={{ page: 0, size: 25, sort: 'createdDate,desc' }}
          requestFunction={ListSourceReportHistory}
          requestKey="ListSourceReportHistory"
          rows={data?.content || []}
          totalPages={data?.totalPages || 1}
          totalRecords={data?.totalElements || 0}
        />
      </Widget>
    </ErrorHandler>
  );
}
